<template>
    <span>
        <b-button
            v-if="button"
            variant="flat-primary"
            :class="buttonClass"
            :id="id"
        >
            <feather-icon icon="InfoIcon" :size="iconSize" />
        </b-button>
        <span
            v-else
            class="text-primary"
            :id="id"
        >
            <feather-icon icon="InfoIcon" :size="iconSize" />
        </span>
        <b-popover
            :target="id"
            triggers="hover"
            :custom-class="customClass"
        >
            <template #title>{{ title }}</template>
            <template #default><span v-html="instruction"/></template>
        </b-popover>
    </span>

</template>

<script>
import {BButton, BPopover} from "bootstrap-vue"
export default {
    components: {BButton, BPopover},
    props: {
        customClass: {
            default: ''
        },
        button: {
            default: true
        },
        buttonClass: {
            default: 'btn-icon'
        },
        instruction: {
            default: ''
        },
        title: {
            default: ''
        },
        variant: {
            default: 'primary'
        },
        iconSize: {
            default: '16'
        }
    },
    data() {
        return {
            id: (Math.random() + 1).toString(36).substring(7)
        }
    }
}
</script>
